import styled from "styled-components"

export const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.gray};
`
